var map = {
	"./Platform_Gradients-1.jpg": "4d66",
	"./Platform_Gradients-10.jpg": "1b6e",
	"./Platform_Gradients-11.jpg": "808a",
	"./Platform_Gradients-12.jpg": "6492",
	"./Platform_Gradients-13.jpg": "d7be",
	"./Platform_Gradients-14.jpg": "99f7",
	"./Platform_Gradients-15.jpg": "34ef",
	"./Platform_Gradients-16.jpg": "bc92",
	"./Platform_Gradients-2.jpg": "7c10",
	"./Platform_Gradients-3.jpg": "7c39",
	"./Platform_Gradients-4.jpg": "8249",
	"./Platform_Gradients-5.jpg": "92437",
	"./Platform_Gradients-6.jpg": "ca36",
	"./Platform_Gradients-7.jpg": "c53f",
	"./Platform_Gradients-8.jpg": "e951",
	"./Platform_Gradients-9.jpg": "b41a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b2b";